"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var o2chart_component_1 = require('./src/o2chart/o2chart.component');
var chart_const_1 = require('./src/o2chart/shared/chart-const');
__export(require('./src/o2chart/o2chart.component'));
__export(require('./src/o2chart/shared/chart-const'));
var O2ChartModule = (function () {
    function O2ChartModule() {
    }
    O2ChartModule.forRoot = function () {
        return {
            ngModule: O2ChartModule,
            providers: []
        };
    };
    O2ChartModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule
            ],
            declarations: [
                chart_const_1.ChartConst,
                o2chart_component_1.O2ChartComponent
            ],
            exports: [
                o2chart_component_1.O2ChartComponent
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], O2ChartModule);
    return O2ChartModule;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = O2ChartModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/o2-chart-lib/dist/index.js
// module id = ../../../../o2-chart-lib/dist/index.js
// module chunks = 3